import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { BehaviorSubject, Subject, combineLatestWith, debounceTime, distinctUntilChanged, map, take } from 'rxjs';
import { DestroyBase } from '../../../../components/common/ng-destroy-base';
import { HttpClient } from '@angular/common/http';
import { AppServiceHelperService } from '../../../../services/app-service-helper.service';

/**
 * User administration using JLL ASA API
 */
@Component({
  selector: 'admin-user-management-asa-search-dialog',
  templateUrl: './admin-user-management-asa-search-dialog.component.html',
  styleUrls: ['./admin-user-management-asa-search-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminUserManagementAsaSearchDialogComponent extends DestroyBase implements OnInit {
  /**
   * Should close?
   */
  public shouldClose = false;

  /**
   * Filter by which property?
   */
  public filterBy = 0;

  /**
   * Filter options
   */
  public filterByOptions = [
    {
      oid: 0,
      description: "Email"
    },
    {
      oid: 1,
      description: "User name"
    },
    {
      oid: 1,
      description: "Display name"
    }
  ];

  /**
   * Filter input
   */
  public filterInput = '';

  /**
   * Search results
   */
  public searchResults: any[] = null;

  /**
   * Loading?
   */
  public isLoading = false;

  /**
   * Cancel event
   */
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  /**
   * Apply event
   */
  @Output() apply: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Filter input subject (for debouncing)
   */
  private filterInput$: Subject<string> = new BehaviorSubject<string>('');

  /**
   * Filter by subject
   */
  private filterBy$: Subject<number> = new BehaviorSubject<number>(0);

  /**
   * Constructor
   * @param http HttpClient
   * @param appServiceHelper AppServiceHelperService
   */
  constructor(private http: HttpClient,
    private appServiceHelper: AppServiceHelperService) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.subscriptions.add(this.filterInput$.pipe(debounceTime(500), distinctUntilChanged())
      .pipe(combineLatestWith(this.filterBy$), map(([filterInput, filterBy]) => { return { filterInput, filterBy }; }))
      .subscribe((searchConfig) => {
        this.performSearch(searchConfig);
      }));
  }

  /**
   * Perform a search
   * @param searchConfig Search config
   */
  private performSearch(searchConfig: { filterInput: string, filterBy: number }) {
    if (searchConfig.filterInput) {
      this.isLoading = true;
      this.http.post<any[]>(this.appServiceHelper.getServiceEndpoint('pollux.settings.api', 'user/asa/search'), searchConfig).pipe(take(1)).subscribe({
        next: (result) => {
          this.isLoading = false;
          this.searchResults = null;
          setTimeout(() => {
            this.searchResults = result;
          });
        }, error: () => {
          this.isLoading = false;
          this.searchResults = null;
        }
      });
    }
  }

  /**
   * Create user callback
   * @param item
   */
  public createUser(item): void {
    this.apply.next(item);
    this.shouldClose = true;
  }

  /**
   * Create user manually callback
   */
  public createUserManually(): void {
    this.createUser(null);
  }

  /**
   * Filter changed
   * @param value
   */
  public onFilterByChanged(value: number): void {
    this.filterBy$.next(value);
  }

  /**
   * Filter input changed
   * @param value
   */
  public onFilterInputChanged(value: string): void {
    this.filterInput$.next(value);
  }

  /**
   * Close clicked
   */
  public close(): void {
    this.shouldClose = true;
    this.cancel.next();
  }
}
